module.exports = __webpack_public_path__ + "img/public/SiteIcons/star.svg?e21f067f";